'use client';
import { useEffect } from 'react';
import { useConstantCallback } from './useConstantCallback';
export const useFocus = (ref, handler) => {
    const constantHandler = useConstantCallback(handler);
    useEffect(() => {
        const refElement = ref.current;
        if (!refElement) {
            return undefined;
        }
        const onFocus = (event) => constantHandler({ event, isFocused: true });
        const onBlur = (event) => constantHandler({ event, isFocused: false });
        refElement.addEventListener('focus', onFocus, { passive: true });
        refElement.addEventListener('blur', onBlur, { passive: true });
        return () => {
            refElement.removeEventListener('focus', onFocus);
            refElement.removeEventListener('blur', onBlur);
        };
    }, [constantHandler, ref]);
    return [ref];
};
